import validate from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.9.2_db0@0.3.2_eslint@9.11.0_jiti@2.4.2_2407868f8ed0be20c0973ee9bbe6a5c7/node_modules/nuxt/dist/pages/runtime/validate.js";
import token_45global from "/app/middleware/token.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.9.2_db0@0.3.2_eslint@9.11.0_jiti@2.4.2_2407868f8ed0be20c0973ee9bbe6a5c7/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  token_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}